import {
  DownloaderRepository,
  HttpMethod,
  HttpModel,
  IFile,
  LegalDocumentType,
} from '@/Shared/domain'
import { axiosFetch, createQueryString } from '@/Shared/infrastructure'
import { downloadLegalDocument, downloadPublicDocumentByLanguage } from '@/Shared/infrastructure/endpoints'

export function createApiDownloaderRepository(): DownloaderRepository {
  return new ApiDownloaderRepository()
}

class ApiDownloaderRepository implements DownloaderRepository {
  async DownloadLegalDocument(
    legalDocumentType: LegalDocumentType,
  ): Promise<HttpModel<IFile>> {
    return await axiosFetch(
      downloadLegalDocument.concat(
        createQueryString({ documentId: legalDocumentType.toString() }),
      ),
      HttpMethod.GET,
    )
  }
  async DownloadPublicDocument(
    legalDocumentType: LegalDocumentType,
  ): Promise<HttpModel<IFile>> {
    return await axiosFetch(
      downloadPublicDocumentByLanguage.concat(
        createQueryString({ documentId: legalDocumentType.toString() }),
      ),
      HttpMethod.GET,
    )
  }
}
